module.exports = __webpack_public_path__ + "img/music-square-search.82bc4f7b.svg";